/**
 * IMPORTS
 */

import { TokenStorage } from "@/data/infra/cache/async-storage";
import { authRepository } from "@/repositories/auth";

/**
 * Anexa o código de uso único à URL do backoffice (preserva o `redirect`).
 * Vai no fragmento (#), que não é enviado ao servidor nem aparece no Referer.
 */
function montarUrlBackoffice(link: string, codigo: string | null): string {
  if (!codigo) return link;

  const url = new URL(link);
  url.hash = new URLSearchParams({ codigo }).toString();
  return url.toString();
}

/**
 * Abre o backoffice já logado com o mesmo usuário do portal.
 *
 * Portal e backoffice ficam em domínios diferentes e não compartilham
 * localStorage, então a API gera um código de uso único que o backoffice
 * troca por uma sessão própria. Se a geração falhar, abre a tela de login.
 */
async function abrirBackoffice(link: string): Promise<void> {
  // abre a aba antes do await: navegadores bloqueiam window.open fora do clique
  const novaAba = window.open("", "_blank");
  if (novaAba) novaAba.opener = null;

  let codigo: string | null = null;
  try {
    const accessToken = await TokenStorage.getAccessToken();
    if (accessToken) codigo = await authRepository.gerarCodigoAcessoBackoffice(accessToken);
  } catch {
    // sem código: o backoffice pede login normalmente
  }

  const url = montarUrlBackoffice(link, codigo);

  if (novaAba) {
    novaAba.location.href = url;
    return;
  }

  window.open(url, "_blank", "noopener,noreferrer");
}

/**
 * EXPORTS
 */
export { abrirBackoffice };
